var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c("m-column-filter", {
        ref: "columnFilterModal",
        on: { apply: _vm.setColumnFilter },
      }),
      _c("files-viewer", { ref: "viewer" }),
      _c(
        "div",
        { staticClass: "inventory-items-table lg" },
        [
          _c(
            "scrolled-table",
            {
              attrs: { "fix-last": true },
              on: {
                nextPage: function ($event) {
                  return _vm.$emit("nextPage")
                },
              },
            },
            [
              _c("table", { staticClass: "h-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.visibleColumns, function (column) {
                        return _c(
                          "th",
                          {
                            key: column.id,
                            attrs: { "data-column": column.id },
                          },
                          [
                            _c("div", { staticClass: "h-table__header" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "h-table__col-title",
                                  class: {
                                    sortable: _vm.activeColumns.includes(
                                      column.id
                                    ),
                                    active: _vm.sortBy === column.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sort(column.id)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(column.fullName) + " ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "h-table__actions" },
                                [
                                  _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover",
                                          content: column.description,
                                          placement: "bottom",
                                        },
                                        expression:
                                          "{\n                      container: '#app',\n                      trigger: 'hover',\n                      content: column.description,\n                      placement: 'bottom',\n                    }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    attrs: { icon: "info", size: "iconic" },
                                  }),
                                  column.id in _vm.filters
                                    ? [
                                        _c("filter-button", {
                                          attrs: {
                                            id:
                                              `uniform-item-table-filter--` +
                                              column.unique,
                                            icon: {
                                              icon: "filter-column",
                                              activeColor: "blue",
                                            },
                                            "no-border": "",
                                            size: "small",
                                            active:
                                              !!_vm.filters[column.id].value,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.configureFilter(
                                                column.id
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "b-popover",
                                          {
                                            attrs: {
                                              id: "h-table-filter-popover",
                                              placement: "top",
                                              triggers: "hover blur",
                                              target:
                                                `uniform-item-table-filter--` +
                                                column.unique,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.filters[column.id].value
                                                    ? "Изменить фильтр"
                                                    : "Применить фильтр"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]
                        )
                      }),
                      _c("th", { attrs: { width: "70" } }),
                    ],
                    2
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.items, function (item) {
                    return _c(
                      "tr",
                      { key: item.id },
                      [
                        _vm._l(_vm.visibleColumns, function (column) {
                          return _c(
                            "td",
                            {
                              key: column.id,
                              class: {
                                expired: !item.isWrittenOff && item.isExpired,
                                "written-off": item.isWrittenOff,
                              },
                              attrs: { "data-column": column.id },
                            },
                            [
                              _c("item-cell", {
                                attrs: { item: item, column: column.id },
                                on: {
                                  showFiles: function ($event) {
                                    return _vm.showItemFiles(item)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        _c(
                          "td",
                          {
                            class: {
                              expired: !item.isWrittenOff && item.isExpired,
                            },
                          },
                          [
                            _c("item-actions", {
                              attrs: {
                                item: item,
                                "can-remove": _vm.canRemove,
                              },
                              on: {
                                edit: function ($event) {
                                  return _vm.$emit("edit", item)
                                },
                                issue: function ($event) {
                                  return _vm.$emit("issue", item)
                                },
                                withdraw: function ($event) {
                                  return _vm.$emit("withdraw", item)
                                },
                                writeOff: function ($event) {
                                  return _vm.$emit("writeOff", item)
                                },
                                restore: function ($event) {
                                  return _vm.$emit("restore", item)
                                },
                                remove: function ($event) {
                                  return _vm.$emit("remove", item)
                                },
                                showHistory: function ($event) {
                                  return _vm.$emit("showHistory", item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]),
            ]
          ),
          _vm.loading
            ? _c("c-loader", {
                staticClass: "inventory-items-table__loading",
                attrs: {
                  active: _vm.loading,
                  label: "Данные загружаются",
                  height: 200,
                },
              })
            : _vm._e(),
          !_vm.loading && !_vm.items.length
            ? _c("div", { staticClass: "inventory-items-table__empty" }, [
                _vm._v(
                  " Ничего не найдено. Попробуйте изменить параметры поиска. "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "inventory-items-table sm" },
        [
          _c(
            "horizontal-table",
            {
              on: {
                nextPage: function ($event) {
                  return _vm.$emit("nextPage")
                },
              },
            },
            [
              _c("table", { staticClass: "h-table" }, [
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.visibleColumns, function (column) {
                      return _c(
                        "tr",
                        {
                          key: column.key,
                          attrs: { "data-column": column.key },
                        },
                        [
                          _c("th", [
                            _c("div", { staticClass: "h-table__header" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "h-table__col-title",
                                  class: {
                                    sortable: _vm.activeColumns.includes(
                                      column.id
                                    ),
                                    active: _vm.sortBy === column.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.sort(column.id)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(column.label) + " ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "h-table__actions" },
                                [
                                  _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover",
                                          content: column.description,
                                          placement: "bottom",
                                        },
                                        expression:
                                          "{\n                      container: '#app',\n                      trigger: 'hover',\n                      content: column.description,\n                      placement: 'bottom',\n                    }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    attrs: { icon: "info", size: "iconic" },
                                  }),
                                  column.id in _vm.filters
                                    ? [
                                        _c("filter-button", {
                                          attrs: {
                                            id:
                                              `uniform-item-table-filter--` +
                                              column.unique,
                                            icon: {
                                              icon: "filter-column",
                                              activeColor: "blue",
                                            },
                                            "no-border": "",
                                            size: "small",
                                            active:
                                              !!_vm.filters[column.id].value,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.configureFilter(
                                                column.id
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "b-popover",
                                          {
                                            attrs: {
                                              id: "h-table-filter-popover",
                                              placement: "top",
                                              triggers: "hover blur",
                                              target:
                                                `uniform-item-table-filter--` +
                                                column.unique,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.filters[column.id].value
                                                    ? "Изменить фильтр"
                                                    : "Применить фильтр"
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]),
                          _vm._l(_vm.items, function (item) {
                            return _c(
                              "td",
                              {
                                key: item.id,
                                class: {
                                  expired: !item.isWrittenOff && item.isExpired,
                                  "written-off": item.isWrittenOff,
                                },
                              },
                              [
                                _c("item-cell", {
                                  attrs: { item: item, column: column.id },
                                  on: {
                                    showFiles: function ($event) {
                                      return _vm.showItemFiles(item)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    }),
                    _c(
                      "tr",
                      [
                        _c("th"),
                        _vm._l(_vm.items, function (item) {
                          return _c(
                            "td",
                            {
                              key: item.id,
                              class: {
                                expired: !item.isWrittenOff && item.isExpired,
                              },
                            },
                            [
                              _c("item-actions", {
                                attrs: {
                                  item: item,
                                  "can-remove": _vm.canRemove,
                                },
                                on: {
                                  edit: function ($event) {
                                    return _vm.edit(item)
                                  },
                                  issue: function ($event) {
                                    return _vm.issue(item)
                                  },
                                  withdraw: function ($event) {
                                    return _vm.withdraw(item)
                                  },
                                  writeOff: function ($event) {
                                    return _vm.writeOff(item)
                                  },
                                  restore: function ($event) {
                                    return _vm.restore(item)
                                  },
                                  remove: function ($event) {
                                    return _vm.remove(item)
                                  },
                                  showHistory: function ($event) {
                                    return _vm.showHistory(item)
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  2
                ),
              ]),
            ]
          ),
          _vm.loading
            ? _c("c-loader", {
                staticClass: "inventory-items-table__loading",
                attrs: {
                  active: _vm.loading,
                  label: "Данные загружаются",
                  height: 200,
                },
              })
            : _vm._e(),
          !_vm.loading && !_vm.items.length
            ? _c("div", { staticClass: "inventory-items-table__empty" }, [
                _vm._v(
                  " Ничего не найдено. Попробуйте изменить параметры поиска. "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }